/* eslint-disable no-underscore-dangle */
import UILocationSearch from './locationsearch';
import LocationService from '../locationservice';

const LOCALE_ITEMS_AVAILABLE = 'Items available in your area';
const LOCALE_DELIVERY_OPTIONS = 'Delivery and collection options for';
const LOCALE_CHECK_AVAILABILITY = 'Check availability in your area';

export function addLocationSearchToProductListView(productListView) {
  /** @type {Boolean} Whethere one autostock check already passed,
   * to prevent repeated checks on LocationService.LocationState.READY */
  productListView.__autoStockCheckDone = false;

  /** @type {UILocationSearch} Filter area location search */
  productListView.__filtersLocationSearch = null;

  /** @type {UILocationSearch} Above listing location search */
  productListView.__resultsLocationSearch = null;

  let elem = document.querySelector('.filters [data-component="locationsearch"]');

  productListView.__filtersLocationSearch = new UILocationSearch(elem, false, null);
  productListView.__filtersLocationSearch.setLabel('Check availability in your area');
  productListView.__filtersLocationSearch.setUseCase('Listing page', 'filter block');

  elem = productListView.__hostElement.querySelector('[data-component="locationsearch"]');
  productListView.__resultsLocationSearch = new UILocationSearch(
    elem, !window.App.settings.get('component.mcd.bluebox.onload'), null
  );
  productListView.__resultsLocationSearch.setUseCase('Listing page', 'above product listing');

  LocationService.addEventListener('locationstatechange', onlocationstatechange, false);
  window.addEventListener('loadAjaxProductsAvailabilities', loadAfterAjaxListingPageChange);

  function onlocationstatechange(event) {
    switch (event.detail.status) {
      case LocationService.LocationState.COMPLETE: {
        // console.log('ProductListView LocationService.LocationState.COMPLETE');
        productListView.__filtersLocationSearch.setLabel(LOCALE_ITEMS_AVAILABLE);
        productListView.__resultsLocationSearch.setLabel(LOCALE_DELIVERY_OPTIONS);
        break;
      }
      case LocationService.LocationState.READY: {
        // console.log('ProductListView LocationService.LocationState.READY');
        productListView.__filtersLocationSearch.setLabel(LOCALE_CHECK_AVAILABILITY);
        productListView.__resultsLocationSearch.setLabel(LOCALE_CHECK_AVAILABILITY);

        if (!productListView.__autoStockCheckDone) {
          doAutoStockCheck();
        }

        break;
      }
      default: {
        break;
      }
    }
  }

  function doAutoStockCheck() {
    const isAutoSearchEnabled = window.App.settings.get('component.mcd.stockchecker.auto');

    if (!isAutoSearchEnabled) {
      return;
    }

    // set the flag to prevent repeated checks on LocationService.LocationState.READY state
    // after first check is done
    productListView.__autoStockCheckDone = true;

    // use the top or side postcode checker component to initiate the autostockcheck
    // according to the component.mcd.bluebox.onload setting
    const locationSearch = window.App.settings.get('component.mcd.bluebox.onload')
      ? productListView.__resultsLocationSearch
      : productListView.__filtersLocationSearch;

    if (!locationSearch) {
      console.log('ProductListView AutoStockCheck can not be performed. ' +
        "There's no UILocationSearch component instance");
      return;
    }

    if (!locationSearch.__input) {
      console.log('ProductListView AutoStockCheck can not be performed. ' +
        'No input DOM element found to grab value.');
      return;
    }

    locationSearch.__textInput = locationSearch.__input.value;
    locationSearch.autocomplete(true);
  }

  function loadAfterAjaxListingPageChange() {
    const locationSearch = productListView.__resultsLocationSearch
      ? productListView.__resultsLocationSearch
      : productListView.__filtersLocationSearch;

    // Set user interaction to TRUE to prevent hiding of location search components during
    // waiting to XHR response.
    if (productListView.__resultsLocationSearch) {
      productListView.__resultsLocationSearch.setUserInteraction(true);
    }

    if (productListView.__filtersLocationSearch) {
      productListView.__filtersLocationSearch.setUserInteraction(true);
    }

    if (!locationSearch) {
      console.log('ProductListView AfterAjaxProductLoad can not be performed. ' +
        'There\'s no UILocationSearch component instance');
    } else {
      locationSearch.searchCurrentLocationDescriptor();
    }
  }
}
